'use client';
import { createContext, Dispatch, SetStateAction, useState } from 'react';

type ResultContextProps = {
    isVehicle0km: boolean;
    isVehicleArmored: boolean;
    setIsVehicle0km: Dispatch<SetStateAction<boolean>>;
    setIsVehicleArmored: Dispatch<SetStateAction<boolean>>;
};

export const ResultContext = createContext<ResultContextProps>({} as ResultContextProps);

export const ResultContextProvider = ({ children }) => {
    const [isVehicle0km, setIsVehicle0km] = useState(false);
    const [isVehicleArmored, setIsVehicleArmored] = useState(false);

    return (
        <ResultContext.Provider value={{ isVehicle0km, isVehicleArmored, setIsVehicle0km, setIsVehicleArmored }}>
            {children}
        </ResultContext.Provider>
    );
};
